import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';

import { FeedByUser, FeedKey, GetFollowedDocument, UserFeedFollow, UserProfile } from 'api';
import { FOLLOW_QUERIES_LIMIT } from 'constants/index';

interface IFollowToggleOptions {
  type: FeedKey;
  currentUser: UserProfile;
}

function getIndex(feedByUser: FeedByUser, result: ExecutionResult, type: FeedKey) {
  const { feed_follows } = feedByUser;

  return feed_follows.findIndex((feedFollow: UserFeedFollow) => {
    const followId = feedFollow[type] && feedFollow[type].id;
    const unfollowedId = result[type].id;

    return followId === unfollowedId;
  });
}

export const followToggle = (
  cache: DataProxy,
  mutationResult: ExecutionResult['data'],
  options: IFollowToggleOptions,
) => {
  const { type, currentUser } = options;
  const cacheOptions = {
    query: GetFollowedDocument,
    variables: { data: { user_id: currentUser.id, limit: FOLLOW_QUERIES_LIMIT } },
  };

  const { getPaginatedUserFeedFollows } = cache.readQuery(cacheOptions);
  const { unfollow, follow } = mutationResult;

  if (unfollow) {
    const index = getIndex(getPaginatedUserFeedFollows, unfollow, type);
    getPaginatedUserFeedFollows.feed_follows.splice(index, 1);
  }

  if (follow) {
    getPaginatedUserFeedFollows.feed_follows.push(follow);
  }

  cache.writeQuery({
    data: { getPaginatedUserFeedFollows },
    ...cacheOptions,
  });
};
